import { TireList, Tires } from "@/@types/Tire";
import { TireListResponse, Tire, LinkMeta } from "../tires/models/TireListResponse";
import { LinkMetaFromList } from "@/@types";

export function mapTireList(response: TireListResponse): TireList {
    return {
        data: {
            Tires: response.data.tires.map((tire: Tire): Tires => {
                return {
                    title: tire.title,
                    slug: tire.slug,
                    industrySlug: tire.industry_slug,
                    image: tire.image,
                };
            }),
        },
        links: {
            first: response.links.first,
            last: response.links.last,
            next: response.links.next,
            prev: response.links.prev,
        },
        meta: {
            currentPage: response.meta.current_page,
            from: response.meta.from,
            lastPage: response.meta.last_page,
            links: response.meta.links.map((link: LinkMeta): LinkMetaFromList => ({
                url: link.url,
                label: link.label,
                active: link.active,
            })),
            path: response.meta.path,
            perPage: response.meta.per_page,
            to: response.meta.to,
            total: response.meta.total,
        },
    }
}